import { categoryListStyles as styles } from "@insite/content-library/Widgets/Category/CategoryList";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.categoryName = {
    ...styles.categoryName,
    css: css`
        color: ${getColor(colorStrings.primaryMain)};
        font-weight: 700;
        padding-top: 16px;

        &:hover {
            text-decoration: underline;
        }
    `,
};

styles.categoryNameLinkItem = {
    ...styles.categoryNameLinkItem,
    css: css`
        ${styles.categoryNameLinkItem?.css}
        padding-top: 16px;
        ${mediaQueriesBP.maxSM} {
            padding-inline: 20px;
        }
    `,
};

styles.categoryImageItem = {
    ...styles.categoryImageItem,
    css: css`
        ${styles.categoryImageItem?.css}
        height: 180px;
        overflow: hidden;
        justify-content: center;

        ${mediaQueriesBP.maxSM} {
            height: 272px;
            padding-inline: 20px;
        }
    `,
};

styles.categoryImage = {
    ...styles.categoryImage,
    width: "180px",
    height: "180px",
    css: css`
        ${styles.categoryImage?.css}
        ${mediaQueriesBP.maxSM} {
            width: 100%;
            height: 272px;

            img {
                height: 100%;
                width: 100%;
                object-fit: contain;
            }
        }
    `,
};

styles.innerContainer = {
    ...styles.innerContainer,
    gap: 0,
    css: css`
        ${mediaQueriesBP.minMD} {
            width: 100%;
            padding: 16px;
        }
    `,
};

styles.categoryItem = {
    ...styles.categoryItem,
    css: css`
        /* the minimum width will be 5 cards  */
        ${mediaQueriesBP.minLG} {
            min-width: calc(100% / 5);
            max-width: calc(100% / 5);
        }
    `,
};
